import React, { lazy } from 'react';

const BankProfileListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/BankProfileModule/BankProfileListing'
  ).then(module => ({ default: module.BankProfileListing })),
);
const BankProfileForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/BankProfileModule/BankProfileForm'
  ).then(module => ({ default: module.BankProfileForm })),
);
const BankProfileDetail = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/BankProfileModule/BankProfileDetail'
  ).then(module => ({ default: module.BankProfileDetail })),
);

//BANK Profile
const bankProfileRoutes = [
  {
    props: {
      exact: true,
      path: '/common-settings/bank-profile',
    },
    component: <BankProfileListing />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/bank-profile/add',
    },
    component: <BankProfileForm mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/bank-profile/edit/:bankProfileID',
    },
    component: <BankProfileForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/bank-profile/detail/:bankProfileID',
    },
    component: <BankProfileDetail />,
  },
];

export default bankProfileRoutes;
